// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"6f7eec1c10f2660188bb","532":"0fa71c02d02d4cd6ca88","691":"d06831e5d402638d3cdb"}[chunkId] + ".js";
};